export default {
	db: [],
	curation: [],
	object: []
}
